export default __webpack_public_path__ + "static/media/property_865.cf3c0097.png";